/* eslint-disable no-unused-expressions */
/* eslint-disable comma-dangle */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable camelcase */
/* eslint-disable no-inner-declarations */
/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
/* eslint-disable object-curly-newline */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import YouTube from 'react-youtube';
import { MdClose } from 'react-icons/md';
import { toast } from 'react-toastify';
// import Slider from 'react-rangeslider';
import Lottie from 'react-lottie';
import AceEditor from 'react-ace';
import Emoji from 'react-emoji-render';
import 'react-rangeslider/lib/index.css';

import 'ace-builds/src-min-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/snippets/html';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/snippets/javascript';
import 'ace-builds/src-noconflict/mode-css';
import 'ace-builds/src-noconflict/snippets/css';
import 'ace-builds/src-noconflict/theme-dracula';

import {
  Container,
  VideoModal,
  ContainerFailed,
  Modal,
  ModalDone,
  CloseModal,
  ImageModal,
} from './styles';
import api from '~/services/api';
import history from '~/services/history';
import loadingContent from '~/assets/animations/loadingContent.json';
import { notShowChallengeVideoRequest } from '~/store/modules/user/actions';

export default function Timeline() {
  const { id } = useParams();
  const user = useSelector((state) => state.user.profile);
  const dispatch = useDispatch();

  const [module, setModule] = useState({});
  const [level, setLevel] = useState('');
  const [modal, setModal] = useState(user.show_video_challenge);

  const [challenges, setChallenges] = useState([]);
  const [index, setIndex] = useState(0);
  const [challenge, setChallenge] = useState('');
  const [challengesSent, setChallengesSent] = useState([]);
  const [challengesSentModule, setChallengesSentModule] = useState([]);
  const [quantity, setQuantity] = useState('');

  const [answer, setAnswer] = useState('');
  const [code, setCode] = useState('');

  const [showVideo, setShowVideo] = useState(false);
  const [showImage, setShowImage] = useState(false);
  // const [grade, setGrade] = useState(5.5);

  useEffect(() => {
    async function getDataModule() {
      const { data } = await api.get(`/modules/${id}`);
      setModule(data);
      setLevel(data.level);
    }

    async function getDataChallenges() {
      const { data } = await api.get(`/modules/${id}/challenges`);
      setChallenges(data);
      setQuantity(data.length);
      setChallenge(data[index]);
      setCode(data[index] ? data[index].ace_editor : null);
    }

    async function getIds() {
      const { data } = await api.get('/allchallenges');
      setChallengesSent(data);
    }

    async function getIdsModule() {
      const { data } = await api.get(`/allchallenges/${id}`);
      setChallengesSentModule(data);
    }

    getDataChallenges();
    getDataModule();
    getIds();
    getIdsModule();
  }, [id, index]);

  const opts = {
    height: '300px',
    width: '100%',
  };

  function handleShowVideo() {
    return showVideo === false ? setShowVideo(true) : setShowVideo(false);
  }

  function handleShowImage() {
    return showImage === false ? setShowImage(true) : setShowImage(false);
  }

  function onLoad() {}

  function onChangeCode(newValue) {
    setCode(newValue);
  }

  const handleInputChange = (e) => {
    const { value } = e.target;
    setAnswer(value);
  };

  function goToNext() {
    if (challenges.length - 1 === index) {
      function reset() {
        setIndex(0);
        setChallenge(challenges[0]);
        const { ace_editor } = challenges[0];
        setCode(ace_editor);
      }

      return reset();
    }
    setShowVideo(false);
    setAnswer('');
    setIndex(index + 1);
    setChallenge(challenges[index + 1]);
    const { ace_editor } = challenges[index + 1];
    setCode(ace_editor);
  }

  function goToPrevious() {
    if (index === 0) {
      function reset() {
        return null;
      }
      return reset();
    }
    setShowVideo(false);
    setAnswer('');
    setIndex(index - 1);
    setChallenge(challenges[index - 1]);
    const { ace_editor } = challenges[index - 1];
    setCode(ace_editor);
  }

  async function handleSubmit(e, idChallenge) {
    e.preventDefault();

    try {
      if (answer) {
        await api.post(`challenges/${idChallenge}/scorecards/`, {
          user_id: user.id,
          link_answer: answer,
          code_answer: '.',
          module_id: challenge.module_id,
        });
        const { data } = await api.get('/allchallenges');
        setChallengesSent(data);
        toast.success('Desafio enviado com sucesso!');
        return goToNext();
      }
      return toast.error('Preencha o campo de resposta e tente novamente.');
    } catch (error) {
      return toast.warn('Desafio já enviado, veja sua página de desafios.');
    }
  }

  async function handleSubmitCode(e, idChallenge) {
    e.preventDefault();

    try {
      if (code.length > 5) {
        await api.post(`challenges/${idChallenge}/scorecards`, {
          user_id: user.id,
          code_answer: code,
          link_answer: '.',
          module_id: challenge.module_id,
        });
        const { data } = await api.get('/allchallenges');
        setChallengesSent(data);
        toast.success('Desafio enviado com sucesso!');
        return goToNext();
      }
      return toast.error('Preencha o campo de resposta e tente novamente.');
    } catch (error) {
      return toast.warning('Desafio já enviado, veja sua página de desafios.');
    }
  }

  function toggleModal() {
    return modal === false ? setModal(true) : setModal(false);
  }

  function notShowEver() {
    const status = false;
    modal === false ? setModal(true) : setModal(false);
    dispatch(notShowChallengeVideoRequest(status));
  }

  if (challenges.length >= 1) {
    return (
      <>
        <Container>
          <>
            <div className="text">
              {modal === true ? (
                <Modal>
                  <button type="button" onClick={toggleModal} className="icon">
                    <MdClose size={30} color="#090f35" />
                  </button>
                  <p>
                    Nossa sugestāo para você realizar os desafios da melhor
                    forma!
                  </p>
                  <YouTube
                    videoId="TiKkqpK5Mms"
                    opts={{ height: '250', width: '100%' }}
                  />
                  <button type="button" className="video" onClick={notShowEver}>
                    Já entendi, nāo precisa me mostrar mais
                  </button>
                </Modal>
              ) : null}
              {showVideo ? (
                <VideoModal>
                  <button type="button" onClick={handleShowVideo}>
                    <MdClose size={30} color="#090f35" />
                  </button>
                  <YouTube videoId={`${challenge.description}`} opts={opts} />
                </VideoModal>
              ) : null}
              {showImage ? (
                <ImageModal>
                  <button type="button" onClick={handleShowImage}>
                    <MdClose size={30} color="#090f35" />
                  </button>
                  <img src={challenge.file.url} alt="imagem-desafio" />
                </ImageModal>
              ) : null}
              <div className="title">
                <p
                  style={{
                    fontSize: 22,
                    fontWeight: 'bold',
                  }}
                >
                  {module.title}
                </p>
                <p
                  style={{
                    fontSize: 14,
                    color: '#aaa',
                  }}
                >
                  {level.title}
                </p>
                <p
                  style={{
                    fontSize: 18,
                    marginTop: 10,
                    fontWeight: 'bold',
                  }}
                >
                  {challenge.position}/{quantity}. {challenge.title}
                </p>
                <p
                  style={{
                    fontSize: 16,
                    marginTop: 10,
                  }}
                >
                  {challenge.question}
                </p>
              </div>
              <div className="description">
                <p className="subtitle">Ajuda</p>
                <p
                  style={{
                    fontSize: 16,
                    marginTop: 10,
                  }}
                >
                  {challenge.help}
                </p>

                {challenge.file_id !== null ? (
                  <button type="button" onClick={handleShowImage}>
                    Imagem de Referência
                  </button>
                ) : null}
                <br />
                {challenge.description === null ? null : (
                  <button type="button" onClick={handleShowVideo}>
                    Vídeo de Referência
                  </button>
                )}
                <br />
                {challenge.link_question === null ? null : (
                  <a
                    href={`${challenge.link_question}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Link de Referência
                  </a>
                )}
              </div>
              <div className="buttons">
                <button
                  type="button"
                  className="exit"
                  onClick={() => history.goBack()}
                >
                  Sair
                </button>

                {index === 0 ? (
                  <button
                    style={{ borderColor: '#ccc' }}
                    type="button"
                    disabled
                  >
                    Início
                  </button>
                ) : (
                  <button type="button" onClick={goToPrevious}>
                    Anterior
                  </button>
                )}
                {challenges.length - 1 === index ? (
                  <button
                    type="button"
                    disabled
                    style={{ borderColor: '#ccc' }}
                  >
                    Fim
                  </button>
                ) : (
                  <button type="button" onClick={goToNext}>
                    Próximo
                  </button>
                )}
              </div>
            </div>
            {challenge.type === 'theory' ? (
              <div className="theory">
                <textarea
                  name="answer"
                  id="answer"
                  placeholder="Digite sua resposta aqui"
                  value={answer}
                  onChange={(value) => handleInputChange(value)}
                />
                {challengesSent.includes(challenge.id) === true ? (
                  <button
                    type="submit"
                    className="disabled"
                    onClick={() =>
                      toast.warning(
                        'Desafio já enviado, veja sua página de desafios.'
                      )
                    }
                  >
                    RESPOSTA JÁ ENVIADA
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="submit"
                    onClick={(e) => handleSubmit(e, challenge.id)}
                  >
                    ENVIAR RESPOSTA
                  </button>
                )}
              </div>
            ) : (
              <div className="code">
                <AceEditor
                  placeholder="Placeholder Text"
                  mode={`${challenge.language}`}
                  theme="dracula"
                  name={challenge.title}
                  onLoad={onLoad}
                  onChange={onChangeCode}
                  fontSize={14}
                  // showPrintMargin
                  // showGutter
                  // highlightActiveLine
                  value={code}
                  width="43vw"
                  height="90vh"
                  setOptions={{
                    enableBasicAutocompletion: true,
                    enableLiveAutocompletion: true,
                    enableSnippets: true,
                    showLineNumbers: true,
                    tabSize: 2,
                  }}
                />
                {challengesSent.includes(challenge.id) === true ? (
                  <button
                    type="submit"
                    className="disabled"
                    onClick={() =>
                      toast.warning(
                        'Desafio já enviado, veja sua página de desafios.'
                      )
                    }
                  >
                    RESPOSTA JÁ ENVIADA
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="submit"
                    onClick={(e) => handleSubmitCode(e, challenge.id)}
                  >
                    ENVIAR RESPOSTA
                  </button>
                )}
              </div>
            )}
          </>
          {challengesSentModule.length === challenges.length ? (
            <CloseModal>
              <ModalDone>
                <h1>Desafios Finalizados</h1>
                <p>
                  Veja seus desafios para saber quais resposta estāo corretas e
                  erradas.
                </p>
                <button
                  type="submit"
                  onClick={() => history.push('/scorecard')}
                >
                  VER MEUS DESAFIOS
                </button>
              </ModalDone>
            </CloseModal>
          ) : null}
          }
        </Container>
      </>
    );
  }
  return (
    <ContainerFailed>
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: loadingContent,
        }}
        height={300}
        width={300}
      />
      <Emoji
        text="Ops! Esse módulo nāo possui desafios ainda."
        style={{ color: '#fff', fontSize: 24, marginTop: -30 }}
      />
      ;
      <button type="submit" onClick={() => history.goBack()}>
        <Emoji
          text="Voltar"
          style={{ color: '#fff', fontSize: 18, fontWeight: 'bold' }}
        />
      </button>
    </ContainerFailed>
  );
}
